import { featureFlags } from '@ui/constants/featureflag';
import { useDataChainId } from '@ui/hooks/datachain';
import { RemoteConfigKey } from '@ui/lib/posthog/hooks/types';
import { useRemoteConfig } from '@ui/lib/posthog/hooks/useRemoteConfig';
import { useEffect, useState } from 'react';

export const useShouldShowMaintenanceBanner = () => {
  const [showMaintenanceBanner, setShowMaintenanceBanner] = useState(false);
  const isEnabled = featureFlags.enableMaintenanceBanner;
  const announcementConfig = useRemoteConfig(RemoteConfigKey.Announcement);
  const chainId = useDataChainId();

  const { targetChains, title } = announcementConfig || {};

  // Note: to make sure the banner is not shown on first load, otherwise it will be shown on page reload on zkSync then flashes away
  useEffect(() => {
    if (!isEnabled) {
      setShowMaintenanceBanner(false);
      
return;
    }
    setShowMaintenanceBanner(targetChains?.includes(chainId) || false);
  }, [chainId, isEnabled, targetChains]);

  if (!isEnabled) return false;
  if (!targetChains || !title) return false;

  return showMaintenanceBanner;
};
